import { useParams } from "react-router-dom";
import { ChangeEvent, useEffect, useState } from "react";
import { CommentsProps } from "../ui";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { selectComments } from "../../../store/comments/repository/selector";
import { getComments } from "../../../store/comments/useCases/getComments/action";
import { readComment } from "../../../store/comments/useCases/readComment/action";
import { answerComment } from "../../../store/comments/useCases/answerComment/action";
import { deleteComment } from "../../../store/comments/useCases/deleteComment/action";
import { useTranslation } from "react-i18next";

export const COMMENT_LIMIT = 30;

export const useComments = ({ type }: CommentsProps) => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  const dispatch = useDispatch();
  const [page, setPage] = useState<number>(0);
  const { isLoading, isActionLoading, comments, pageAmount } =
    useSelector(selectComments);

  const handlePageChange = (event: ChangeEvent<unknown>, page: number) => {
    setPage(page - 1);
  };

  const handleViewAll = () => {
    dispatch(
      readComment({
        id,
        type,
        all: true,
      })
    );
  };

  const handleView = (id: string) => {
    dispatch(
      readComment({
        id,
        type,
      })
    );
  };

  const handleReply = (parentId: string, text: string) => {
    dispatch(
      answerComment({
        parentId,
        text,
        type,
      })
    );
  };

  const handleDelete = (id: string) => {
    dispatch(
      deleteComment({
        id,
        type,
      })
    );
  };

  useEffect(() => {
    dispatch(
      getComments({
        id,
        type,
        limit: COMMENT_LIMIT,
        offset: page * COMMENT_LIMIT,
      })
    );
  }, [type, id, page]);

  return {
    t,
    page: page === 0 ? 1 : page + 1,
    handlePageChange,
    pageAmount: Math.ceil(pageAmount / COMMENT_LIMIT),
    handleViewAll,
    handleView,
    handleReply,
    handleDelete,
    comments,
    isLoading,
    isActionLoading,
  };
};
